<!--用户页面-->
<template>
    <v-main>
        <top-bar
            :height="'48vh'"
            title="用户"
            addTitle="添加管理员"
            :loading="loading"
            :isShowRefresh="true"
            @refresh="refresh"
            @add="add"
            @search="search"
        />
        <v-container fluid class="mt-n6">
            <el-tabs v-model="activeName" tab-position="top" @tab-click="handleClick" class="pa-3">
                <el-tab-pane v-for="(tab, index) in tabs" :key="index" :name="tab.name">
                    <span
                        slot="label"
                        :style="{
                            color: activeName === tab.name ? '#4dabf7' : theme.pageFontColor,
                        }"
                    >
                        {{ tab.lable }}
                    </span>
                    <v-card flat outlined :color="theme.pageBgColor">
                        <admin-table
                            v-if="tab.lable == '管理员'"
                            :adminData="adminData"
                            @modifyPermis="refresh"
                        />
                        <ordinary-table v-else :ordinaryData="ordinaryData" />
                    </v-card>
                </el-tab-pane>
            </el-tabs>
        </v-container>
        <v-dialog scrollable v-model="isAdd" width="35em" overlay-color="#262626">
            <user-form @cancel="cancel" />
        </v-dialog>
    </v-main>
</template>

<script>
import util from "@/util";
import TopBar from "@/components/TopBar";
import OrdinaryTable from "@/components/Table/OrdinaryTable";
import AdminTable from "@/components/Table/AdminTable";
import UserForm from "@/components/Form/UserForm";
import store from "@/store";
import { mapState } from "vuex";
export default {
    name: "User",
    data() {
        return {
            loading: false,
            isAdd: false,
            activeName: "first",
            ordinaryData: [], //用户数据
            adminData: [], //管理员数据
            tabIndex: null,
            tabs: [
                {
                    name: "first",
                    lable: "普通用户",
                },
                {
                    name: "second",
                    lable: "会员",
                },
                {
                    name: "third",
                    lable: "管理员",
                },
            ],
        };
    },
    mounted() {
        this.refresh();
    },
    computed: {
        ...mapState(["theme", "pageLoading"]),
    },
    components: {
        OrdinaryTable,
        AdminTable,
        UserForm,
        TopBar,
    },
    methods: {
        refresh() {
            this.ordinaryData = [
                {
                    id: 1,
                    name: "小明",
                    balance: "100",
                    phone: "12345678",
                    lastTime: "2021-1-14 12:23:23",
                },
            ];
            if (this.tabIndex === "2") {
                this.getAdmin();
            }
        },
        handleClick(tab, event) {
            this.tabIndex = tab.index;
            if (this.tabIndex === "0") {
                this.refresh();
            }
            if (this.tabIndex === "1") {
                this.ordinaryData = [
                    {
                        id: 2,
                        name: "小黑",
                        balance: "100",
                        phone: "12345678",
                        lastTime: "2021-1-14 12:23:23",
                    },
                ];
            }
            if (this.tabIndex === "2") {
                this.adminData = [
                    {
                        id: 1,
                        name: "admin",
                        role: 0,
                        status: 0,
                        lastTime: "2021-1-14 12:23:23",
                    },
                ];
                this.getAdmin();
            }
        },
        /*搜索*/
        search(parameter) {
            console.log(parameter);
        },
        /*添加管理*/
        add() {
            this.isAdd = true;
        },
        cancel() {
            this.isAdd = false;
        },
        /*获取管理员信息*/
        getAdmin() {
            this.loading = true;
            let postData = {
                from: 0,
                limit: 10000,
            };
            this.loading = false;
        },
    },
};
</script>
